import React, {useEffect} from "react";
import * as StorageService from "../services/StorageService.js";
import {LOCALSTORAGE_ITEMS, ORDER_PLACE} from "../util/Constants";
import {PATH} from "../routes/routes";
import * as AccountService from "../services/AccountService";
import {clearStorageItems, getAppLocale, handleAppVersionUpdate} from "../util/common";
import {useNavigate} from "react-router";
import {useParams} from "react-router-dom";

function BarPickupScan(props) {
    const navigateTo = useNavigate();
    const {shopName} = useParams();
    const shopNameStorage = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME) ? StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME) : null;
    const localeStorage =  StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE) : null;
    useEffect(() => {
        handleAppVersionUpdate();

        if (shopNameStorage !== shopName || getAppLocale() !== localeStorage) {
            clearStorageItems();
            StorageService.setItem(LOCALSTORAGE_ITEMS.SHOP_NAME, shopName);
        }
        StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_TABLE);
        StorageService.removeItem(LOCALSTORAGE_ITEMS.ORDER_ID);
        StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS);
        StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
        StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, ORDER_PLACE.BAR);
        AccountService.configApp().then(r=> {
            navigateTo(PATH.ALL_PRODUCTS);
        });

    }, []);

    return (
        <div className="redirect-msg">
            Redirecting...
        </div>

    );
}

export default BarPickupScan;
